module.exports = __webpack_public_path__ + "static/media/account_settings.b8e4e8cd.svg";